import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=b8c62e4c&scoped=true&lang=pug"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=b8c62e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c62e4c",
  null
  
)

export default component.exports